import { defineFcm } from '../shared/factory';

export const FCM_BETA_LOCALES_ENABLED = defineFcm('beta_locales_enabled').asBoolean().withDefault(false).toConfig();
